<list-view *ngIf="listeZonesParametrables" [liste]="listeZonesParametrables"></list-view>

<floating-button [listeActions]="listeActions"></floating-button>